<template>
  <div class="quick-register-step1">
    <div class="header-section">
      <h1 class="main-title">
        <span class="highlight">Teste grátis</span> por 3 dias
      </h1>
      <p class="subtitle">Depois, R$97/mês — cancele quando quiser.</p>
    </div>

    <form @submit.prevent="handleSubmit" class="register-form">
      <!-- Suas informações pessoais -->
      <section class="form-section">
        <h2 class="section-title">Suas informações pessoais</h2>

        <div class="person-type mb-3">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="kindOfPerson"
              id="person-type-natural"
              value="NATURAL_PERSON"
              v-model="formData.kindOfPerson"
              required
            />
            <label class="form-check-label" for="person-type-natural">
              Pessoa física
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="kindOfPerson"
              id="person-type-legal"
              value="LEGAL_PERSON"
              v-model="formData.kindOfPerson"
              required
            />
            <label class="form-check-label" for="person-type-legal">
              Pessoa jurídica
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="email" class="form-label">E-mail</label>
            <input
              id="email"
              type="email"
              class="form-control"
              v-model="formData.email"
              placeholder="Digite seu e-mail para receber o acesso."
              required
            />
          </div>

          <div class="col-12 mb-3">
            <label for="email-confirmation" class="form-label">
              Confirme seu e-mail
            </label>
            <input
              id="email-confirmation"
              type="email"
              class="form-control"
              v-model="formData.emailConfirmation"
              placeholder="Digite novamente para confirmar."
              required
              @paste.prevent
            />
            <div v-if="emailMismatch" class="text-danger small mt-1">
              Os e-mails não coincidem
            </div>
          </div>

          <div class="col-12 mb-3">
            <label for="legal-name" class="form-label">
              {{
                formData.kindOfPerson === "NATURAL_PERSON"
                  ? "Nome completo"
                  : "Razão Social"
              }}
            </label>
            <input
              id="legal-name"
              type="text"
              class="form-control"
              v-model="formData.legalName"
              placeholder="Como está no documento."
              required
            />
          </div>

          <div class="col-6 mb-3">
            <label for="reg-number" class="form-label">
              {{ formData.kindOfPerson === "NATURAL_PERSON" ? "CPF" : "CNPJ" }}
            </label>
            <input
              id="reg-number"
              type="text"
              class="form-control"
              v-model="formData.regNumber"
              v-maska="
                formData.kindOfPerson === 'NATURAL_PERSON'
                  ? '###.###.###-##'
                  : '##.###.###/####-##'
              "
              placeholder="Apenas números."
              required
            />
          </div>

          <div class="col-6 mb-3">
            <label for="phone" class="form-label">Celular</label>
            <input
              id="phone"
              type="tel"
              class="form-control"
              v-model="formData.phone"
              v-maska="'(##) #####-####'"
              placeholder="Com DDD"
              required
            />
          </div>

          <!-- Endereço -->
          <div class="col-8 mb-3">
            <label for="address-line-1" class="form-label">Endereço</label>
            <input
              id="address-line-1"
              type="text"
              class="form-control"
              v-model="formData.addressLine1"
              placeholder="Rua, avenida, etc."
              required
            />
          </div>

          <div class="col-4 mb-3">
            <label for="address-number" class="form-label">Número</label>
            <input
              id="address-number"
              type="text"
              class="form-control"
              v-model="formData.addressNumber"
              required
            />
          </div>

          <div class="col-5 mb-3">
            <label for="address-line-2" class="form-label">Complemento</label>
            <input
              id="address-line-2"
              type="text"
              class="form-control"
              v-model="formData.addressLine2"
              placeholder="Apto, bloco, etc. (opcional)"
            />
          </div>

          <div class="col-7 mb-3">
            <label for="address-line-3" class="form-label">Bairro</label>
            <input
              id="address-line-3"
              type="text"
              class="form-control"
              v-model="formData.addressLine3"
              required
            />
          </div>

          <div class="col-5 mb-3">
            <label for="city" class="form-label">Cidade</label>
            <input
              id="city"
              type="text"
              class="form-control"
              v-model="formData.city"
              required
            />
          </div>

          <div class="col-3 mb-3">
            <label for="state" class="form-label">Estado</label>
            <select
              id="state"
              class="form-select"
              v-model="formData.state"
              required
            >
              <option value="">UF</option>
              <option value="AC">AC</option>
              <option value="AL">AL</option>
              <option value="AP">AP</option>
              <option value="AM">AM</option>
              <option value="BA">BA</option>
              <option value="CE">CE</option>
              <option value="DF">DF</option>
              <option value="ES">ES</option>
              <option value="GO">GO</option>
              <option value="MA">MA</option>
              <option value="MT">MT</option>
              <option value="MS">MS</option>
              <option value="MG">MG</option>
              <option value="PA">PA</option>
              <option value="PB">PB</option>
              <option value="PR">PR</option>
              <option value="PE">PE</option>
              <option value="PI">PI</option>
              <option value="RJ">RJ</option>
              <option value="RN">RN</option>
              <option value="RS">RS</option>
              <option value="RO">RO</option>
              <option value="RR">RR</option>
              <option value="SC">SC</option>
              <option value="SP">SP</option>
              <option value="SE">SE</option>
              <option value="TO">TO</option>
            </select>
          </div>

          <div class="col-4 mb-3">
            <label for="postal-code" class="form-label">CEP</label>
            <input
              id="postal-code"
              type="text"
              class="form-control"
              v-model="formData.postalCode"
              v-maska="'#####-###'"
              required
            />
          </div>
        </div>
      </section>

      <!-- Informações de pagamento -->
      <section class="form-section">
        <h2 class="section-title">Informações de pagamento</h2>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="card-number" class="form-label">Número do cartão</label>
            <input
              id="card-number"
              type="text"
              class="form-control"
              v-model="formData.cardNumber"
              v-maska="'#### #### #### ####'"
              placeholder="Digite os 16 dígitos do seu cartão."
              maxlength="19"
              required
            />
          </div>

          <div class="col-12 mb-3">
            <label for="card-holder-name" class="form-label"
              >Nome no cartão</label
            >
            <input
              id="card-holder-name"
              type="text"
              class="form-control"
              v-model="formData.cardHolderName"
              placeholder="Como aparece no cartão."
              required
            />
          </div>

          <div class="col-6 mb-3">
            <label for="card-expiry" class="form-label">
              Validade
              <i class="bi bi-lock-fill ms-1"></i>
            </label>
            <input
              id="card-expiry"
              type="text"
              class="form-control"
              v-model="cardExpiry"
              v-maska="'##/##'"
              placeholder="Mês/ano"
              required
            />
          </div>

          <div class="col-6 mb-3">
            <label for="card-ccv" class="form-label">
              CVV
              <i
                class="bi bi-question-circle ms-1"
                title="Os 3 dígitos no verso."
              ></i>
            </label>
            <input
              id="card-ccv"
              type="text"
              class="form-control"
              v-model="formData.cardCcv"
              v-maska="'###'"
              placeholder="Os 3 dígitos no verso."
              maxlength="3"
              required
            />
          </div>
        </div>
      </section>

      <!-- Mensagens de erro/sucesso -->
      <div v-if="errorMessage" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>

      <!-- Botão de submissão -->
      <div class="button-container">
        <button
          type="submit"
          class="btn btn-submit"
          :disabled="loading || emailMismatch"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
          ></span>
          Começar teste grátis agora
        </button>
      </div>

      <!-- Nota de segurança -->
      <div class="security-note">
        <LockIcon />
        Seus dados estão protegidos com segurança de nível bancário.
      </div>

      <div class="payment-badge">
        Pagamento seguro com
        <img
          src="@/assets/images/asaas_logo.svg"
          alt="asaas logo"
          height="16"
          style="vertical-align: baseline; margin-bottom: -1px"
        />
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useMutation } from "@vue/apollo-composable";
import { gql } from "@apollo/client/core";
import { useQuickRegisterStore } from "@/stores/quickRegister";
import { getMessageFromError } from "@/libs/errors";
import LockIcon from "@/components/icons/LockIcon.vue";

const router = useRouter();
const quickRegisterStore = useQuickRegisterStore();

const loading = ref(false);
const errorMessage = ref("");

const formData = ref({
  kindOfPerson: "NATURAL_PERSON" as "NATURAL_PERSON" | "LEGAL_PERSON",
  email: "",
  emailConfirmation: "",
  legalName: "",
  regNumber: "",
  phone: "",
  addressLine1: "",
  addressNumber: "",
  addressLine2: "",
  addressLine3: "",
  city: "",
  state: "",
  postalCode: "",
  cardNumber: "",
  cardHolderName: "",
  cardCcv: "",
});

const cardExpiry = ref("");

const emailMismatch = computed(() => {
  if (!formData.value.emailConfirmation) return false;
  return formData.value.email !== formData.value.emailConfirmation;
});

const { mutate: quickRegister } = useMutation(gql`
  mutation QuickRegister($input: QuickRegisterInput!) {
    quickRegister(input: $input) {
      userId
      subscriptionId
      token
      trialExpiresAt
    }
  }
`);

const handleSubmit = async () => {
  errorMessage.value = "";

  if (emailMismatch.value) {
    errorMessage.value = "Os e-mails não coincidem. Por favor, verifique.";
    return;
  }

  loading.value = true;

  try {
    // Extrair mês e ano da validade
    const [month, year] = cardExpiry.value.split("/");
    const fullYear = year ? `20${year}` : "";

    // Preparar input para a mutation quickRegister
    const input = {
      email: formData.value.email,
      kindOfPerson: formData.value.kindOfPerson,
      legalName: formData.value.legalName,
      regNumber: formData.value.regNumber.replace(/\D/g, ""),
      phone: formData.value.phone.replace(/\D/g, ""),
      postalCode: formData.value.postalCode.replace(/\D/g, ""),
      addressLine1: formData.value.addressLine1,
      addressNumber: formData.value.addressNumber,
      addressLine2: formData.value.addressLine2 || "",
      addressLine3: formData.value.addressLine3 || "",
      city: formData.value.city,
      state: formData.value.state,
      creditCard: {
        number: formData.value.cardNumber.replace(/\s/g, ""),
        holderName: formData.value.cardHolderName,
        expiryMonth: month,
        expiryYear: fullYear,
        ccv: formData.value.cardCcv,
      },
    };

    // Chamar mutation para criar usuário + subscription trial
    const result = await quickRegister({ input });
    const data = result?.data;

    if (data && data.quickRegister) {
      const { userId, subscriptionId, token, trialExpiresAt } = data.quickRegister;

      // Salvar dados no store para uso na próxima etapa
      quickRegisterStore.saveStep1Data({
        kindOfPerson: formData.value.kindOfPerson,
        email: formData.value.email,
        emailConfirmation: formData.value.emailConfirmation,
        legalName: formData.value.legalName,
        regNumber: formData.value.regNumber.replace(/\D/g, ""),
        phone: formData.value.phone.replace(/\D/g, ""),
        addressLine1: formData.value.addressLine1,
        addressNumber: formData.value.addressNumber,
        addressLine2: formData.value.addressLine2,
        addressLine3: formData.value.addressLine3,
        city: formData.value.city,
        state: formData.value.state,
        postalCode: formData.value.postalCode.replace(/\D/g, ""),
        cardNumber: formData.value.cardNumber,
        cardHolderName: formData.value.cardHolderName,
        cardExpiryMonth: month,
        cardExpiryYear: fullYear,
        cardCcv: formData.value.cardCcv,
      });

      // Salvar token, userId e subscriptionId
      quickRegisterStore.saveStep1Result(token, userId, subscriptionId);

      // Armazenar token no localStorage para autenticação automática no Step 2
      localStorage.setItem("auth_token", token);

      // Ir para a próxima etapa
      router.push("/auth/register/finalize");
    } else {
      errorMessage.value =
        "Não foi possível processar o cadastro. Tente novamente.";
    }
  } catch (err) {
    errorMessage.value = getMessageFromError(err);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.quick-register-step1 {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 2rem 1rem;
}

.quick-register-step1 > * {
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}

.header-section {
  text-align: center;
  margin-bottom: 2.5rem;
  background: #16161d;
  padding: 1.5rem;
  border-radius: 12px;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #fff;
}

.main-title .highlight {
  color: #a6c715;
}

.subtitle {
  font-size: 0.95rem;
  color: #fff;
  margin: 0;
}

.form-section {
  background: #ffffff;
  padding: 2rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #1a1a1a;
}

.person-type {
  display: flex;
  gap: 1.5rem;
}

.person-type .form-check-label {
  color: #333;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 0.9rem;
}

.form-control,
.form-select {
  background: #f8f8f8;
  border: 1px solid #d0d0d0;
  color: #333;
  padding: 0.75rem;
  border-radius: 8px;
}

.form-control:focus,
.form-select:focus {
  background: #fff;
  border-color: #a6c715;
  color: #333;
  box-shadow: 0 0 0 0.2rem rgba(166, 199, 21, 0.25);
}

.form-control::placeholder {
  color: #999;
}

.form-check-input:checked {
  background-color: #a6c715;
  border-color: #a6c715;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.btn-submit {
  background: #a6c715;
  color: #16161d;
  font-weight: 700;
  font-size: 1.1rem;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-submit:hover:not(:disabled) {
  background: #8fa612;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(166, 199, 21, 0.4);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.security-note {
  text-align: center;
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.lock-icon {
  flex-shrink: 0;
}

.payment-badge {
  text-align: center;
  font-size: 0.85rem;
  color: #666;
}

.payment-badge strong {
  color: #a6c715;
}

.alert {
  margin-bottom: 1rem;
}

.text-danger {
  color: #dc3545;
}

/* Ajustes para telas pequenas */
@media (max-width: 768px) {
  .quick-register-step1 {
    padding: 1rem 0.5rem;
  }

  .form-section {
    padding: 1.5rem 1rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .btn-submit {
    max-width: 100%;
    font-size: 1rem;
    padding: 0.875rem 1.5rem;
  }
}

/* Breakpoint para telas muito pequenas (≤479px) */
@media (max-width: 479px) {
  .quick-register-step1 {
    padding: 0.75rem 0.5rem;
  }

  .form-section {
    padding: 1.25rem 0.75rem;
  }

  .section-title {
    font-size: 1.1rem;
  }
}
</style>
